import { useEffect, useState } from "react";
import type { PaymentMethod } from "@ai-pos/shared";
import { paymentMethodsApi } from "../api/resources.js";

interface FormState {
  id: string | null;
  name: string;
  code: string;
  isActive: boolean;
  sortOrder: number;
}

export function PaymentMethodAdmin() {
  const [methods, setMethods] = useState<PaymentMethod[]>([]);
  const [form, setForm] = useState<FormState | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  const load = () => {
    paymentMethodsApi
      .list()
      .then((res) => setMethods(res.paymentMethods))
      .catch((err: unknown) => setError(err instanceof Error ? err.message : "取得に失敗しました"));
  };

  useEffect(load, []);

  const handleSave = async () => {
    if (!form) return;
    setSaving(true);
    setError(null);
    try {
      if (form.id) {
        await paymentMethodsApi.update(form.id, {
          name: form.name,
          code: form.code,
          isActive: form.isActive,
          sortOrder: form.sortOrder,
        });
      } else {
        await paymentMethodsApi.create({ name: form.name, code: form.code, isActive: form.isActive, sortOrder: form.sortOrder });
      }
      setForm(null);
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "保存に失敗しました");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="stack">
      <div className="row">
        <h2 style={{ flex: 1 }}>支払方法管理</h2>
        <button className="btn btn-primary" onClick={() => setForm({ id: null, name: "", code: "", isActive: true, sortOrder: methods.length })}>
          新規追加
        </button>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="card">
        <table>
          <thead>
            <tr>
              <th>名称</th>
              <th>コード</th>
              <th>状態</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {methods.map((method) => (
              <tr key={method.id}>
                <td>{method.name}</td>
                <td>{method.code}</td>
                <td>{method.isActive ? <span className="badge">有効</span> : <span className="badge badge-danger">停止</span>}</td>
                <td>
                  <button
                    className="btn"
                    onClick={() =>
                      setForm({ id: method.id, name: method.name, code: method.code, isActive: method.isActive, sortOrder: method.sortOrder })
                    }
                  >
                    編集
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {form && (
        <div className="modal-backdrop" onClick={() => setForm(null)}>
          <div className="modal stack" onClick={(e) => e.stopPropagation()}>
            <h3>{form.id ? "支払方法編集" : "新規支払方法"}</h3>
            <div className="form-field">
              <label htmlFor="pm-name">名称</label>
              <input id="pm-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            </div>
            <div className="form-field">
              <label htmlFor="pm-code">コード（英数字）</label>
              <input id="pm-code" value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} disabled={!!form.id} />
            </div>
            <label className="row" style={{ gap: 6 }}>
              <input
                type="checkbox"
                checked={form.isActive}
                onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
                style={{ minHeight: "auto", width: 20, height: 20 }}
              />
              有効
            </label>
            <div className="row">
              <button className="btn" onClick={() => setForm(null)}>
                キャンセル
              </button>
              <button className="btn btn-primary" onClick={() => void handleSave()} disabled={saving || !form.name || !form.code}>
                保存
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
